import * as Types from '../actions/Types'

const INITIAL_STATE = {
  isCreating: [], // [{ timeId, date }]
  errorCreating: null,
  isDeleting: [], // [bookingId]
  errorDeleting: false
}

export default (state = INITIAL_STATE, action) => {
  const { payload, type } = action

  switch (type) {
    case Types.CREATE_BOOKING_FOR_BOOKING_SYSTEM:
      return {
        ...state,
        isCreating: [...state.isCreating, payload],
        errorCreating: null
      }
    case Types.CREATE_BOOKING_FOR_BOOKING_SYSTEM_SUCCESS:
      return {
        ...state,
        isCreating: state.isCreating.filter(
          booking =>
            booking.timeId.toString() !== payload.loading.timeId.toString() &&
            booking.date !== payload.loading.date
        ),
        errorCreating: null
      }
    case Types.CREATE_BOOKING_FOR_BOOKING_SYSTEM_FAILED:
      return {
        ...state,
        isCreating: state.isCreating.filter(
          booking =>
            booking.timeId.toString() !== payload.loading.timeId.toString() &&
            booking.date !== payload.loading.date
        ),
        errorCreating: payload.status
      }
    case Types.DELETE_BOOKING_FOR_BOOKING_SYSTEM:
      return {
        ...state,
        isDeleting: [...state.isDeleting, payload],
        errorDeleting: false
      }
    case Types.DELETE_BOOKING_FOR_BOOKING_SYSTEM_SUCCESS:
      return {
        ...state,
        isDeleting: state.isDeleting.filter(id => id !== payload.bookingId),
        errorDeleting: false
      }
    case Types.DELETE_BOOKING_FOR_BOOKING_SYSTEM_FAILED:
      return {
        ...state,
        isDeleting: state.isDeleting.filter(id => id !== payload),
        errorDeleting: true
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/BookingSystemBookings.js